import React from 'react';
import { Body } from '@lendi-ui/typography';

export interface ErrorMessageProps {
  field: string;
  errors: Record<string, any>;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ field, errors }: ErrorMessageProps) => {
  const fieldError = errors[field];
  if (!fieldError) return null;

  return (
    <Body data-testid="field-error-message" size="xs" color="error.500" align="left" mt="xxs" mb="md">
      {fieldError.message}
    </Body>
  );
};

export default ErrorMessage;
